import { useState } from "react";

const Waitlist = () => {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [focused, setFocused] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const formData = new FormData(event.target);
    const data = Object.fromEntries(formData.entries());
    try {
      const response = await fetch("/api/waitlist", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      if (response.ok) {
        setSubmitted(true);
      } else {
        alert("There was an error joining the waitlist. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("There was an error joining the waitlist. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#0e0e0e",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Cormorant Garamond', Georgia, serif",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <link
        href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&display=swap"
        rel="stylesheet"
      />

      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(ellipse at 30% 20%, rgba(180,140,60,0.06) 0%, transparent 60%), radial-gradient(ellipse at 70% 80%, rgba(180,140,60,0.04) 0%, transparent 50%)",
          pointerEvents: "none",
        }}
      />

      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "500px",
          height: "500px",
          border: "0.5px solid rgba(180,140,60,0.06)",
          borderRadius: "50%",
          pointerEvents: "none",
        }}
      />

      <div
        style={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          maxWidth: "480px",
          padding: "3rem 2rem",
          textAlign: "center",
        }}
      >
        <div
          style={{
            display: "inline-block",
            border: "",
            padding: "8px 12px",
            marginBottom: "2.5rem",
          }}
        >
          <svg
            width="80"
            height="80"
            viewBox="0 0 129.53 129.53"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              display: "block",
            }}
          >
            <defs>
              <style>
                {`.cls-1 {
                  fill: none;
                  stroke: #c8a855;
                  stroke-miterlimit: 10;
                  stroke-width: 3px;
                }
                .cls-2 {
                  fill: #c8a855;
                }`}
              </style>
            </defs>
            <g id="Layer_1-2" data-name="Layer 1">
              <g>
                <rect className="cls-1" x="1.5" y="1.5" width="126.53" height="126.53"/>
                <g>
                  <path className="cls-2" d="M37.6,26.51v7.46h-15.58v8.06h11.66v7.25h-11.66v15.48h-9.32V26.51h24.9Z"/>
                  <path className="cls-2" d="M51.82,26.51v38.25h-9.32V26.51h9.32Z"/>
                  <path className="cls-2" d="M78.09,64.76l-7.96-14.44h-2.23v14.44h-9.32V26.51h15.64c3.01,0,5.59.53,7.71,1.58,2.12,1.05,3.71,2.5,4.77,4.33,1.05,1.83,1.58,3.88,1.58,6.13,0,2.54-.72,4.81-2.15,6.81-1.44,2-3.55,3.42-6.35,4.25l8.83,15.15h-10.52ZM67.9,43.73h5.78c1.71,0,2.99-.42,3.84-1.25.85-.84,1.28-2.02,1.28-3.54s-.43-2.6-1.28-3.43c-.85-.84-2.13-1.25-3.84-1.25h-5.78v9.48Z"/>
                  <path className="cls-2" d="M103.43,33.98v7.74h12.48v7.19h-12.48v8.39h14.11v7.46h-23.43V26.51h23.43v7.46h-14.11Z"/>
                  <path className="cls-2" d="M32.56,80.5v22.18h-5.4v-9.13h-8.41v9.13h-5.4v-22.18h5.4v8.69h8.41v-8.69h5.4Z"/>
                  <path className="cls-2" d="M41.21,101.45c-1.74-.97-3.12-2.32-4.14-4.06-1.02-1.74-1.53-3.69-1.53-5.86s.51-4.12,1.53-5.85c1.02-1.73,2.4-3.08,4.14-4.04,1.74-.97,3.65-1.45,5.74-1.45s4,.49,5.74,1.45,3.11,2.32,4.11,4.04c1,1.73,1.5,3.68,1.5,5.85s-.51,4.12-1.52,5.86c-1.01,1.74-2.38,3.09-4.11,4.06-1.73.97-3.63,1.45-5.72,1.45s-4-.49-5.74-1.45ZM51.19,96.21c1.06-1.18,1.6-2.74,1.6-4.68s-.53-3.52-1.6-4.69c-1.06-1.17-2.48-1.75-4.25-1.75s-3.22.58-4.28,1.74c-1.06,1.16-1.6,2.73-1.6,4.71s.53,3.52,1.6,4.69c1.06,1.17,2.49,1.75,4.28,1.75s3.19-.59,4.25-1.77Z"/>
                  <path className="cls-2" d="M66.6,80.5v13.27c0,1.33.33,2.35.98,3.07.65.72,1.61,1.08,2.88,1.08s2.23-.36,2.91-1.08c.67-.72,1.01-1.74,1.01-3.07v-13.27h5.4v13.24c0,1.98-.42,3.66-1.26,5.02-.84,1.37-1.98,2.4-3.4,3.1-1.42.7-3.01,1.04-4.76,1.04s-3.31-.34-4.69-1.03c-1.38-.68-2.47-1.72-3.27-3.1-.8-1.38-1.2-3.06-1.2-5.04v-13.24h5.4Z"/>
                  <path className="cls-2" d="M87.23,102.12c-1.29-.53-2.31-1.31-3.08-2.34-.77-1.03-1.17-2.28-1.22-3.73h5.75c.08.82.37,1.45.85,1.88.48.43,1.12.65,1.9.65s1.43-.18,1.9-.55c.46-.37.69-.88.69-1.53,0-.55-.18-1-.55-1.36-.37-.36-.82-.65-1.36-.88s-1.3-.5-2.29-.79c-1.43-.44-2.6-.88-3.51-1.33s-1.69-1.1-2.34-1.96c-.65-.86-.98-1.99-.98-3.38,0-2.06.75-3.68,2.24-4.85,1.5-1.17,3.44-1.75,5.85-1.75s4.41.58,5.91,1.75c1.5,1.17,2.3,2.8,2.4,4.88h-5.85c-.04-.72-.31-1.28-.79-1.69-.49-.41-1.11-.62-1.86-.62-.65,0-1.18.17-1.58.52-.4.35-.6.85-.6,1.5,0,.72.34,1.27,1.01,1.67s1.73.83,3.16,1.3c1.43.48,2.6.95,3.49,1.39.9.44,1.67,1.08,2.32,1.93.65.84.98,1.93.98,3.25s-.32,2.41-.96,3.44-1.57,1.85-2.8,2.46c-1.22.61-2.67.92-4.33.92s-3.08-.26-4.36-.79Z"/>
                  <path className="cls-2" d="M108.41,84.83v4.49h7.24v4.17h-7.24v4.87h8.19v4.33h-13.59v-22.18h13.59v4.33h-8.19Z"/>
                </g>
              </g>
            </g>
          </svg>
        </div>

        <div
          style={{
            width: "40px",
            height: "1px",
            background:
              "linear-gradient(90deg, transparent, rgba(200,175,100,0.4), transparent)",
            margin: "0 auto 2rem",
          }}
        />

        <p
          style={{
            fontSize: "13px",
            letterSpacing: "4px",
            color: "rgba(200,175,100,0.5)",
            textTransform: "uppercase",
            margin: "0 0 0.75rem",
            fontFamily: "system-ui, -apple-system, sans-serif",
          }}
        >
          Introducing
        </p>

        <h2
          style={{
            fontSize: "clamp(2.2rem, 5.5vw, 3rem)",
            fontWeight: 300,
            color: "#f0ece4",
            margin: "0 0 0.5rem",
            lineHeight: 1.15,
            letterSpacing: "1px",
          }}
        >
          The Monthly Serve
        </h2>

        <p
          style={{
            fontSize: "16px",
            color: "rgba(224,220,212,0.4)",
            margin: "0 0 2.5rem",
            letterSpacing: "3px",
            textTransform: "uppercase",
            fontFamily: "system-ui, -apple-system, sans-serif",
          }}
        >
          Subscription Box
        </p>

        <div
          style={{
            margin: "0 auto 2.5rem",
            padding: "1.25rem 1.5rem",
            borderTop: "0.5px solid rgba(200,175,100,0.2)",
            borderBottom: "0.5px solid rgba(200,175,100,0.2)",
            maxWidth: "400px",
          }}
        >
          <p
            style={{
              fontSize: "clamp(1.1rem, 3vw, 1.35rem)",
              lineHeight: 1.6,
              color: "#c8a855",
              margin: 0,
              fontWeight: 400,
              fontStyle: "italic",
            }}
          >
            3 cocktails delivered to your door for less than a round in town.
          </p>
        </div>

        <p
          style={{
            fontSize: "17px",
            lineHeight: 1.8,
            color: "rgba(224,220,212,0.5)",
            margin: "0 0 2.5rem",
            fontWeight: 300,
            maxWidth: "380px",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          Be the first to experience our curated monthly cocktail box, featuring
          Fire House spirits, house-made syrups, and everything you need to
          shake, pour, and sip.
        </p>

        {submitted ? (
          <div
            style={{
              padding: "2.5rem 2rem",
              border: "0.5px solid rgba(200,175,100,0.2)",
              borderRadius: "2px",
              background: "rgba(200,175,100,0.03)",
              animation: "fadeIn 0.6s ease",
            }}
          >
            <div
              style={{
                width: "48px",
                height: "48px",
                border: "1.5px solid rgba(200,175,100,0.4)",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 1.5rem",
              }}
            >
              <svg
                width="20"
                height="16"
                viewBox="0 0 20 16"
                fill="none"
                stroke="#c8a855"
                strokeWidth="1.5"
              >
                <path d="M1 8l6 6L19 1" />
              </svg>
            </div>
            <h3
              style={{
                fontSize: "1.4rem",
                fontWeight: 400,
                color: "#f0ece4",
                margin: "0 0 0.75rem",
              }}
            >
              You're on the list
            </h3>
            <p
              style={{
                fontSize: "15px",
                color: "rgba(224,220,212,0.5)",
                margin: 0,
                fontWeight: 300,
                fontStyle: "italic",
              }}
            >
              We'll be in touch when The Monthly Serve launches.
            </p>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1.25rem",
              maxWidth: "360px",
              margin: "0 auto",
            }}
          >
            {[
              {
                id: "name",
                label: "Name",
                type: "text",
                placeholder: "Your full name",
              },
              {
                id: "email",
                label: "Email",
                type: "email",
                placeholder: "your@email.com",
              },
              {
                id: "postcode",
                label: "Postcode",
                type: "text",
                placeholder: "HD4 5UX",
              },
            ].map((field) => (
              <div key={field.id} style={{ textAlign: "left" }}>
                <label
                  htmlFor={field.id}
                  style={{
                    display: "block",
                    fontSize: "12px",
                    letterSpacing: "3px",
                    textTransform: "uppercase",
                    color:
                      focused === field.id
                        ? "rgba(200,175,100,0.7)"
                        : "rgba(224,220,212,0.35)",
                    marginBottom: "8px",
                    transition: "color 0.3s ease",
                    fontFamily: "system-ui, -apple-system, sans-serif",
                  }}
                >
                  {field.label}
                </label>
                <input
                  type={field.type}
                  id={field.id}
                  name={field.id}
                  required
                  placeholder={field.placeholder}
                  onFocus={() => setFocused(field.id)}
                  onBlur={() => setFocused(null)}
                  style={{
                    width: "100%",
                    padding: "14px 16px",
                    boxSizing: "border-box",
                    background: "rgba(255,255,255,0.03)",
                    border:
                      focused === field.id
                        ? "0.5px solid rgba(200,175,100,0.4)"
                        : "0.5px solid rgba(255,255,255,0.08)",
                    borderRadius: "2px",
                    color: "#f0ece4",
                    fontSize: "16px",
                    fontFamily: "'Cormorant Garamond', Georgia, serif",
                    fontWeight: 300,
                    letterSpacing: "0.5px",
                    outline: "none",
                    transition: "border-color 0.3s ease, background 0.3s ease",
                  }}
                />
              </div>
            ))}

            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%",
                marginTop: "0.75rem",
                background: loading
                  ? "rgba(200,175,100,0.15)"
                  : "transparent",
                color: loading ? "rgba(200,175,100,0.5)" : "#c8a855",
                border: "1px solid rgba(200,175,100,0.4)",
                padding: "16px 2rem",
                borderRadius: "2px",
                fontSize: "13px",
                fontWeight: 500,
                textTransform: "uppercase",
                letterSpacing: "4px",
                cursor: loading ? "not-allowed" : "pointer",
                transition: "all 0.3s ease",
                fontFamily: "system-ui, -apple-system, sans-serif",
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={(e) => {
                if (!loading) {
                  e.target.style.background = "rgba(200,175,100,0.1)";
                  e.target.style.borderColor = "rgba(200,175,100,0.6)";
                }
              }}
              onMouseLeave={(e) => {
                if (!loading) {
                  e.target.style.background = "transparent";
                  e.target.style.borderColor = "rgba(200,175,100,0.4)";
                }
              }}
            >
              {loading ? "Joining..." : "Join the waitlist"}
            </button>

            <p
              style={{
                fontSize: "14px",
                color: "rgba(224,220,212,0.25)",
                margin: "0.5rem 0 0",
                fontWeight: 300,
                fontStyle: "italic",
              }}
            >
              Founding members get first access
            </p>
          </form>
        )}

        <div
          style={{
            marginTop: "3.5rem",
            display: "flex",
            justifyContent: "center",
            gap: "2.5rem",
          }}
        >
          {["3 cocktails monthly", "Letterbox friendly", "Cancel anytime"].map(
            (text) => (
              <span
                key={text}
                style={{
                  fontSize: "12px",
                  letterSpacing: "2px",
                  color: "rgba(224,220,212,0.2)",
                  textTransform: "uppercase",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                }}
              >
                {text}
              </span>
            )
          )}
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        ::placeholder {
          color: rgba(224,220,212,0.2);
          font-style: italic;
        }
        ::selection {
          background: rgba(200,175,100,0.3);
          color: #f0ece4;
        }
      `}</style>
    </div>
  );
};

export default Waitlist;
